import React from 'react';

import Config from '../../config/Config';
import WidgetAttribute from '../../widget/WidgetAttribute';

class AttributeSearch extends React.Component
{
    constructor( props )
    {
        super(props);
        
        const basePath = Config.getBasePath();

        this.state = {
            basePath : basePath,
            attributes:[],
            conditions:undefined,
            fromState:false
        }

        this.notify = this.notify.bind(this);
        this.clearAttributeFilter = this.clearAttributeFilter.bind(this)
    }

    componentDidMount()
    {
        let conditions  = {};

        if( this.props.values!==undefined )
        {
            conditions = {...this.props.values};
        }

        this.setState({ attributes: this.props.attributes, conditions:conditions});
    }

    componentWillReceiveProps( nextProps )
    {
        let { attributes, fromState} = this.state, conditions = {};

        if( nextProps.attributes!==attributes )
        {
            attributes = [];

            attributes = [...nextProps.attributes];
        } 

        if( fromState!==true && nextProps.values!==undefined )
        {
            conditions = {...nextProps.values};
        }
        else
        {
            conditions = {...this.state.conditions};
        }

        this.setState({attributes:attributes, conditions:conditions, fromState:false});
    }

    notify( attributeFilter )
    {
        this.setState({ conditions:attributeFilter });

        this.state["fromState"] = true;

        if( this.props.notify!==undefined )
        {
            this.props.notify(attributeFilter);
        }
    }

    clearAttributeFilter()
    {
        this.setState({attributes:[],conditions:undefined})
    }

    render()
    {
        let { attributes, conditions } = this.state;

        return <WidgetAttribute attributes={attributes} notify={this.notify} conditions={conditions} flag={this.props.flag} block={this.props.block}></WidgetAttribute>
    }
}

export default AttributeSearch
